import { API_BASE_URL, HEADERS_WITH_TOKEN } from "./BaseUrl";

export const getCities = () =>
  fetch(
    `${API_BASE_URL}/cities`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn'))
    }
  )
  .then(res => res.json())


export const saveCity = async (params) => {
  const res = await fetch(
    `${API_BASE_URL}/cities`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const editCity = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/cities/${id}`,
    {
      method: 'PUT',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const deleteCity = async (id) => {
  const res = await fetch(
    `${API_BASE_URL}/cities/${id}`,
    {
      method: 'DELETE',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn'))
    }
  )
  return await res.json()
}

// Orders
export const editCityOrder = async (params) => {
  const res = await fetch(
    `${API_BASE_URL}/cities/order`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}